import { Employee } from '@models/employee.model';
import { graphQlClient } from '@config/graphqlClient';
import EmployeesGraphQL from '@graphql/employee.queries';

export interface EmployeesFilter {
  text?: string | null;
  role?: string | null;
  id?: string | null;
  page?: number | null;
  limit?: number | null;
  organizationRoleStatus?: string | null;
  /**
   * Restrict results to users the signed-in user outranks (peers included).
   * Opt-in: the project-assignment pickers reuse this query and must keep
   * listing project managers and superintendents to a superintendent.
   */
  hierarchyScoped?: boolean;
}

export const employeesService = {
  async getEmployees(filter?: EmployeesFilter): Promise<{
    employees: Employee[];
    total: number;
    page: number;
    limit: number;
  }> {
    const data: any = await graphQlClient.request(
      (EmployeesGraphQL as any).queries.getEmployeesFiltered,
      { filterBy: filter || {} },
    );
    return {
      employees: data?.getEmployeesFiltered?.employees || [],
      total: data?.getEmployeesFiltered?.total || 0,
      page: data?.getEmployeesFiltered?.page || 1,
      limit: data?.getEmployeesFiltered?.limit || 10,
    };
  },

  // Unpaginated full roster for the current organization. Use when a consumer
  // needs the complete list (e.g. crew member pickers) rather than a page.
  async getAllEmployees(): Promise<Employee[]> {
    const data: any = await graphQlClient.request(
      (EmployeesGraphQL as any).queries.getEmployees,
    );
    return data?.getEmployees || [];
  },
};

export default employeesService;
